import Cookies from 'js-cookie';

export const expiresNotificationPrefix = 'EXPIRES_NOTIFICATION_HIDDEN';
export const sessionNotificationPrefix = 'SESSION_NOTIFICATION_HIDDEN';

export const sessionNotificationOptions: Cookies.CookieAttributes = {
    domain: window.location.hostname,
    path: '/',
};
